import React from 'react';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import Icon from '../../../../../../../../../../../../../../../../components/icon/index';
import {collaboratorStatusCleaner} from '../../../../../../../../../../../../../../../../utils/index';
import {
	enteredCollaboratorSearchValue,
	getSharingDetailsLv2Popup,
	findCollaborators,
	updateCollaborators, getChangedStatus, selectedCollaborator, getSharingDetailsPopup
} from '../../../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import './index.css';

class UserStatuses extends React.Component {

	constructor(props){
		super(props);

		this.openPopup = this.openPopup.bind(this);
		this.goToDomainGroupDetails = this.goToDomainGroupDetails.bind(this);
		 this.timeIntervalFunc = 0
	}

	componentWillUnmount (){
		clearInterval(this.timeIntervalFunc);

	}

	openPopup(e){
		e.preventDefault();

		let cTarget = e.currentTarget;

		if(this.props.sharingDetailsPopup.length > 0){
			this.props.getSharingDetailsLv2Popup([true, "user_collaboratorStatuses", cTarget.dataset.messageFor, this.props.collaboratorEmail, this.props.collaboratorType]);
		} else {

			this.props.getSharingDetailsPopup([true, "user_collaboratorStatuses", cTarget.dataset.messageFor, this.props.collaboratorEmail, this.props.collaboratorType]);
		}

	}

	goToDomainGroupDetails(){

		if(this.props.updateCollaborators.length > 0){
			this.props.setUpdateCollaborators([])
		}

		if(this.props.enteredCollaboratorSearchValue !== ""){
			this.props.setEnteredCollaboratorSearchValue("");
		}

		if (this.props.changedStatus){
			this.props.setChangedStatus(false);
		}

		this.props.setSelectedCollaborator({
			"id": this.props.collaboratorId,
			"name": this.props.collaboratorName,
			"email": this.props.collaboratorEmail,
			"type": this.props.collaboratorType,
			"statuses": this.props.collaboratorStatuses,
			"permission": this.props.collaboratorPermission,
			"synced": true,
			"hiddenFields": this.props.collaboratorHiddenFields
		});

		//this.props.enteredCollaboratorSearchValue("");
		if(document.querySelector(".data-list__head input")){
			document.querySelector(".data-list__head input").value = "";
		}
	}

	sortedStatuses = [
		{id:0, icon:'check', color:'#00cc00', status:'normal'},
		{id:1, icon:'clock-o', color:'#ffcc00', status:'invitationPending'},
        {id:2, icon:'warning', color:'#cc0000', status:'invitationWarning'},
		{id:3, icon:'minus-circle', color:'#cc0000', status:'suspended'},
		{id:4, icon:'user-times', color:'#cc0000', status:'licenseLimitReached'},
		{id:5, icon:'warning', color:'#ffcc00', status:'partiallyShared'},
		{id:6, icon:'times-circle', color:'#cc0000', status:'revoked'},
		{id:7, icon:'minus-circle', color:'#cc0000', status:'overQuota'},
		{id:8, icon:'minus-circle', color:'#cc0000', status:'sharingLimitReached'},
		{id:9, icon:'user-times', color:'#cc0000', status:'deleted'},
		{id:10, icon:'gavel', color:'#cc0000', status:'banned'},
		{id:11, icon:'question-circle-o', color:'#cc0000', status:'unknown'},
		{id:12, icon:'level-up', color:'#cc0000', status:'upgradeNow'},
		{id:13, icon:'level-up', color:'#cc0000', status:'contactLimitReached'}
	];

	displayStatus(){

		let statusArray = [];

		this.sortedStatuses.forEach( sortedStatus => {
			for(let i = 0; i < Object.keys(this.props.collaboratorStatuses).length; i++){
				if(sortedStatus.status === Object.keys(this.props.collaboratorStatuses)[i]){
					if(Object.values(this.props.collaboratorStatuses)[i] === true){
                        statusArray = statusArray.concat(sortedStatus);
					}
				}
			}
		});

		if(this.props.selectedCollaboratorMode && !this.props.showHiddenFields){
			return (
				<div className="user-status">
                    {
                        statusArray[statusArray.length - 1].status !== 'normal'
                            ?
                            <Icon className="mr-1" name={'warning'} color={'#ffcc00'}/>
                            :
                            <Icon className="mr-1" name={'check'} color={'#00cc00'}/>
                    }
					{
						statusArray[statusArray.length - 1].status !== 'normal'
							?
							<span style={{color: '#ffcc00'}}>{collaboratorStatusCleaner('partiallyShared')}</span>
							:
							''
					}
				</div>
			)
		} else {

			return (
				<div className="user-status">
					{
                        this.props.collaboratorType === "user"
						?
                            <div className="d-flex justify-content-center">
								<Icon className="mr-1" name={statusArray[statusArray.length - 1].icon} color={statusArray[statusArray.length - 1].color}/>
                                {
                                    statusArray[statusArray.length - 1].status !== 'normal'
                                    ?
                                        <span style={{whiteSpace:'nowrap', color: statusArray[statusArray.length - 1].color}}>{collaboratorStatusCleaner(statusArray[statusArray.length - 1].status)}</span>
                                    :
                                        ''
                                }
                            </div>
						:
                            statusArray[statusArray.length - 1].status !== 'normal'
							?
                                statusArray[statusArray.length - 1].status === 'upgradeNow'
								?
                                    <div className="d-flex justify-content-center">
                                        <Icon className="mr-1" name={statusArray[statusArray.length - 1].icon} color={statusArray[statusArray.length - 1].color}/>
                                        <span style={{whiteSpace:'nowrap', color: '#cc0000'}}>{collaboratorStatusCleaner('upgradeNow')}</span>
                                    </div>
								:
									<div className="d-flex justify-content-center">
										<Icon className="mr-1" name={'warning'} color={'#ffcc00'}/>
										<span style={{whiteSpace:'nowrap', color: '#ffcc00'}}>{collaboratorStatusCleaner('partiallyShared')}</span>
									</div>
							:
								<div className="d-flex justify-content-center">
									<Icon className="mr-1" name={statusArray[statusArray.length - 1].icon} color={statusArray[statusArray.length - 1].color}/>
									<span style={{whiteSpace:'nowrap', color: '#00cc00'}}>{collaboratorStatusCleaner('normal')}</span>
								</div>
					}
					{
						statusArray[statusArray.length - 1].status !== 'normal' && this.props.collaboratorType === "user"
							?
							<p>
								<button
									data-collaborator-id={this.props.collaboratorId}
									data-collaborator-email={this.props.collaboratorEmail}
									data-message-for={statusArray[statusArray.length - 1].status}
									className="btn btn-link more p-0 text-nowrap"
									onClick={this.openPopup}>{this.props.t("popupSharingMoreInfo")}</button>
							</p>
							:
							''
					}
					{
						this.props.collaboratorType === "group"
						?

                            statusArray[statusArray.length - 1].status !== 'normal'
							?

								statusArray[statusArray.length - 1].status === 'overQuota'
								?
									<p>
										<a href={`/api/payment/add`} target="_blank" className="more text-nowrap" rel="noreferrer">{this.props.t("textGCMAddLicenses")}</a>
									</p>
								:
									statusArray[statusArray.length - 1].status === 'upgradeNow'
									?
										<p>
											<button
												data-collaborator-id={this.props.collaboratorId}
												data-collaborator-email={this.props.collaboratorEmail}
												data-message-for={statusArray[statusArray.length - 1].status}
												className="btn btn-link more p-0 text-nowrap"
												onClick={this.openPopup}>{this.props.t("popupSharingMoreInfo")}</button>
										</p>
									:
                                        <p>
                                            <button
                                                className="btn btn-link more p-0 text-nowrap"
                                                onClick={this.goToDomainGroupDetails}
                                            >{this.props.t("textViewGroupMembers")}</button>
                                        </p>
							:
								<p>
									<button
										className="btn btn-link more p-0 text-nowrap"
										onClick={this.goToDomainGroupDetails}
									>{this.props.t("textViewGroupMembers")}</button>
								</p>
						:
							''
					}
				</div>
			);
		}

	}

	render() {
		return (
			this.displayStatus()
		)
	}
}

const mapStateToProps = (state) => {
	return {
		isSyncing : state.syncStatusReducer.isSyncing,
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		changedStatus: state.sharingDetailsReducer.getChangedStatus,
		showHiddenFields: state.sharingDetailsReducer.showHiddenFields,
		enteredCollaboratorSearchValue: state.sharingDetailsReducer.enteredCollaboratorSearchValue,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSharingDetailsPopup : (array) => {
			dispatch(getSharingDetailsPopup(array))
		},
        getSharingDetailsLv2Popup : (array) => {
            dispatch(getSharingDetailsLv2Popup(array))
        },
		setSelectedCollaborator : (object) => {
			dispatch(selectedCollaborator(object))
		},
		setEnteredCollaboratorSearchValue  : (string) => {
			dispatch(enteredCollaboratorSearchValue(string))
		},
		setFindCollaborators : (labelId, pageSize) => {
			dispatch(findCollaborators(labelId, pageSize))
		},
		setUpdateCollaborators : (array) => {
			dispatch(updateCollaborators(array))
		},
		setChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		}
	}
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UserStatuses));
